/**
 * win name 的操作方法
 * @Author: moonye
 * @Date: 2018-08-10 19:39:39
 * @Last Modified by: moonye
 * @Last Modified time: 2019-05-09 21:38:55
 */
export default {
  set: function (name, value) {
    this.del(name);
    var _str = name + '=' + value;
    window.name = !window.name ? _str : window.name + '&' + _str;
  },
  get: function (name) {
    var m = window.name && window.name.match(new RegExp('(^|&)' + name + '=([^&]*)(&|$)'));
    return !m ? '' : decodeURIComponent(m[2]);
  },
  del: function (name) {
    var v = this.get(name);
    if (v) {
      window.name = window.name.replace(new RegExp('(^|&)' + name + '=([^&]*)(&|$)'), '$3');
    }
  }
};